module.exports = __webpack_public_path__ + "img/523-2ef88a.png";